<template>
  <Modal
    :value="visible"
    @on-cancel="cancelHandler"
    footer-hide
    :title="curEventRule && curEventRule.index >= 0 ? '编辑事件' : '增加事件'"
    width="600"
  >
    <div class="container">
      <Form :model="formData" ref="form" :label-width="100">
        <form-item-conditions v-model="formData.conditions"/>
        <FormItem label="动作" prop="action">
          <Row :gutter="16">
            <Col span="12">
              <Select v-model="formData.action">
                <Option value="hangup">挂机</Option>
                <Option value="hmc">触发协同提醒</Option>
                <Option value="sms">发送短信</Option>
                <Option value="api">接口调用</Option>
              </Select>
            </Col>
            <Col span="12">
              <FormItemApiSetting v-if="formData.action === 'api'" v-model="formData.action_data" />
              <SkillSelect v-if="formData.action === 'hmc' && access.userSkill" v-model="formData.action_data"/>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="只执行一次" prop="action">
          <i-switch v-model="formData.first_valid"/>
        </FormItem>
        <div class="flex flex-end">
          <Button style="margin-right: 20px" @click="cancelHandler"
            >取消</Button
          >
          <Button type="primary" @click="submit">确定</Button>
        </div>
      </Form>
    </div>
  </Modal>
</template>
<script>
import { mapState } from "vuex";
import cloneDeep from "lodash/cloneDeep";
import FormItemConditions from '../../../components/FormItemConditions.vue';
import FormItemApiSetting from '../../../components/FormItemApiSetting.vue';
import SkillSelect from '../../../components/SkillSelect.vue';

export default {
  components: { FormItemConditions, FormItemApiSetting, SkillSelect },
  model: {
    prop: "visible",
    event: "change",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curEventRule: {
      type: Object,
    },
  },
  data() {
    return {
      formData: {
        conditions: [],
        action: "",
        action_data: "",
        first_valid: true,
      },
    };
  },
  computed: {
    ...mapState("setting", ["sysVars", "vars"]),
    ...mapState('user', ['access']),
  },
  watch: {
    curEventRule(val) {
      if (!val) return;
      this.formData = {
        ...cloneDeep(val),
        first_valid: val.first_valid,
      };
    },
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const formData = this.formData;
        this.$emit("onSubmit", {
          ...formData,
          // first_valid: formData.first_valid === "1",
        });
        this.cancelHandler();
      });
    },
    cancelHandler() {
      this.$refs.form.resetFields();
      this.formData = {
        conditions: [],
        action: "",
        action_data: "",
        first_valid: true,
      };
      this.$emit("change", false);
      this.$emit("onCancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.conditionIcon {
  cursor: pointer;
  margin-left: 5px;
}
</style>
